// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "element-ui/lib/theme-chalk/index.css";
// 全局样式表;
import "../src/assets/css/global.css";
import "../src/assets/css/font.css";
import 'animate.css';
import '../src/utils/rem.js'


// 注册全局组件
import PageBottom from "./components/PageBottom.vue";
import PageTop from "./components/PageTop.vue";
import PageNav from "./components/PageNav.vue";
import ElementUI from "element-ui";
import "swiper/dist/js/swiper";
import "swiper/dist/css/swiper.css";
Vue.use(ElementUI);
Vue.component("PageTop", PageTop);
Vue.component("PageBottom", PageBottom);
Vue.component("PageNav", PageNav);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js